// extracted by mini-css-extract-plugin
module.exports = {"root":"SlideInSidebar_root__nRjME","overlay":"SlideInSidebar_overlay__gi1N8","sidebar":"SlideInSidebar_sidebar__WG0Bc","close":"SlideInSidebar_close__nzVhL"};